"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _RightPaneWidgetFrame = _interopRequireDefault(require("../01_atoms/RightPaneWidgetFrame"));

var _PassengerSelectionWidget = _interopRequireDefault(require("./PassengerSelectionWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PassengersSelectionRightPane = function PassengersSelectionRightPane(_ref) {
  var _ref$scrollTop = _ref.scrollTop,
      scrollTop = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop,
      _ref$focusedLeftItemI = _ref.focusedLeftItemId,
      focusedLeftItemId = _ref$focusedLeftItemI === void 0 ? null : _ref$focusedLeftItemI,
      props = _objectWithoutProperties(_ref, ["scrollTop", "focusedLeftItemId"]);

  var sdk = props.sdk,
      savedPassengers = props.savedPassengers,
      selectedPassengers = props.selectedPassengers,
      numberOfPassengers = props.numberOfPassengers,
      onPassengerToggle = props.onPassengerToggle,
      _props$onAddPassenger = props.onAddPassenger,
      onAddPassenger = _props$onAddPassenger === void 0 ? function () {} : _props$onAddPassenger,
      _props$onConfirmPasse = props.onConfirmPassengers,
      onConfirm = _props$onConfirmPasse === void 0 ? function () {} : _props$onConfirmPasse;
  var translatorForNamespace = sdk.i18n.translatorForNamespace;
  var t = translatorForNamespace('PassengersSelectionUI');
  var title = t('Passengers in this trip');

  var subtitle = /*#__PURE__*/_react["default"].createElement("span", null, t('We need to know the names of the passengers on this trip'), /*#__PURE__*/_react["default"].createElement("br", null), t('Please insert their details below'));

  if (savedPassengers.length > 0) {
    subtitle = /*#__PURE__*/_react["default"].createElement("span", null, t('Use this screen to indicate who will be on this trip.'), /*#__PURE__*/_react["default"].createElement("br", null), t('{XofY} passengers confirmed', {
      XofY: "".concat(selectedPassengers.length, "/").concat(numberOfPassengers)
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_RightPaneWidgetFrame["default"], {
    scrollTop: scrollTop,
    focusedLeftItemId: focusedLeftItemId
  }, /*#__PURE__*/_react["default"].createElement(_PassengerSelectionWidget["default"], {
    title: title,
    subtitle: subtitle,
    translatorForNamespace: translatorForNamespace,
    savedPassengers: savedPassengers,
    selectedPassengers: selectedPassengers,
    numberOfPassengers: numberOfPassengers,
    onPassengerToggle: onPassengerToggle,
    onAddPassenger: onAddPassenger,
    onConfirm: onConfirm,
    translator: t
  }));
};

var _default = PassengersSelectionRightPane;
exports["default"] = _default;